import React, { useState, useEffect, useRef } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import UploadService from "./upload-files.service";
import axios from "../../../../api/axios";

import {
  Paper,
  Box,
  Grid,
  Typography,
  responsiveFontSizes,
  TextField,
} from "@mui/material";
import Divider from "@mui/material/Divider";
import {
  GridRowModes,
  DataGrid,
  GridToolbarContainer,
  GridActionsCellItem,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import { useLocation } from "react-router-dom";
import { url } from "../../../../configlink";
import { useSelector } from "react-redux";

// function FileUpload(props) {
function FileUpload() {
  const [selectedFiles, setSelectedFiles] = useState(undefined);
  const [progressInfos, setProgressInfos] = useState({ val: [] });
  const [message, setMessage] = useState([]);
  const [fileInfos, setFileInfos] = useState([]);
  const progressInfosRef = useRef(null);
  const [rows, setRows] = useState([]);

let adminUser = useSelector((state) => state.userAdmin.userAdmin)

  let loc = useLocation()
  let props = {
    selectedOrderId: loc.search.split('&')[0].split('=')[1],
    selectedUserId: loc.search.split('=')[2]
  }

  console.log(props);
  
  const selectFiles = (event) => {
    setSelectedFiles(event.target.files);
    setProgressInfos({ val: [] });
  };

  useEffect(() => {
    if (props.selectedOrderId != undefined) {
      //alert('final selected' + props.selectedOrderId + "   userid==" + props.selected);
      getUploadedFileList();
    }
  }, [props.selectedOrderId]);

  const getUploadedFileList = async () => {
    try {
      const response = await axios.get(
        `${url}/api/admin/get_uploaded_file_lists_by_orderid`,
        {
          params: { orderId: props.selectedOrderId },
			withCredentials: true,
			headers: {
				'acgt-admin': adminUser
			},
        }
      );

      console.log('rows', response.data);
      
      setRows(response.data);
    } catch (error) {
      console.error(error);
    }
  };

  const columns = [
    { field: "id", headerName: "Id", type: "number", hide: false, width: 100 },
    {
      field: "FileName",
      headerName: "File Name",
      type: "string",
      width: 520,
      editable: false,
    },
    // {
    //   field: "UploadDate",
    //   headerName: "Date",
    //   type: "string",
    //   width: 220,
    //   editable: false,
    // },
    {
      field: "actions",
      type: "actions",
      headerName: "",
      width: 50,
      cellClassName: "actions",
      getActions: ({ id }) => {
        return [
          <GridActionsCellItem
            key={id}
            icon={<DeleteIcon />}
            label='Edit'
            onClick={() => disableZipFile(id)}
            className='textPrimary'
            color='inherit'
            style={{position:'relative', left:10}}
          />,
        ];
      },
    },
  ];


  function disableZipFile(x){
    console.log(x);
    
    let conf = window.confirm("Disable Zip file?")

      if(conf){
        try {
          fetch(`${url}/api/admin/disable_zipfile?id=${x}`,{
            method:"PUT",
				credentials: 'include',
				headers: {
					'acgt-admin': adminUser
				},
          })
          .then(res => res.json())
          .then(data => {
            if(data.message === 'success'){
              alert("Success")
              getUploadedFileList()
            }
          })
          .catch(err => console.error(err))
        } catch (error) {
          console.error(error)
        }
      }
  }

  const upload = async (idx, file) => {
    let arrFile = file.name.split('.');
    if (arrFile.length != 2) return;

    let mode = 'data';
    let orderId = arrFile[0];
    let _progressInfos = [...progressInfosRef.current.val];
    return UploadService.upload(file, props.selectedOrderId, props.selectedUserId, mode, event => {
      _progressInfos[idx].percentage = Math.round((100 * event.loaded) / event.total);
      setProgressInfos({ val: _progressInfos });
    })
      .then(() => {
        setMessage(prevMessage => [...prevMessage, 'Uploaded successfully: ' + file.name + '\n\n']);
        getUploadedFileList();
        console.log('file upload completed ');
      })
      .catch(() => {
        _progressInfos[idx].percentage = 0;
        setProgressInfos({ val: _progressInfos });

        setMessage(prevMessage => [...prevMessage, 'Could not upload the file: ' + file.name + '\n\n' ]);
      });
  };

  const uploadFiles = (event) => {
    event.preventDefault();

    
    const files = Array.from(selectedFiles);
    console.log(files);

    let _progressInfos = files.map((file) => ({
      percentage: 0,
      fileName: file.name,
    }));
    progressInfosRef.current = {
      val: _progressInfos,
    };

    try {
      const uploadPromises = files.map((file, i) => upload(i, file));
      Promise.all(uploadPromises).then((files) => {
        setFileInfos(files.data);
      });
    } catch (error) {
      console.log(error);
      // Expected output: ReferenceError: nonExistentFunction is not defined
      // (Note: the exact output may be browser-dependent)
    }
    setMessage([]);
  };

  const divStyle = {
    overflowY: "auto",
    overflowX:'hidden',
    width: "100%",
    // float: "left",
    maxHeight: "230px",
    border: '1px solid gray',
    padding: '0 0 10px 0'
  };

  return (
    <div >
      <Box sx={{ width: "100%", bgcolor: "background.paper", px: 2 }}>
        <Box sx={{ my: 3 }}>
          <Grid container alignItems='center' spacing={1}>
            <Grid item xs>
              {/* any elements nested inside the role="presentation" preserve their semantics. */}
              <Typography gutterBottom variant='h5' component='div' className='text-[var(--color-primary-purple)]'>
                Order #{props.selectedOrderId}
              </Typography>
            </Grid>
          </Grid>
          <Divider component='div' role='presentation' />
        </Box>
        

          <Grid>
            <Grid item xs>
              <p className="font-semibold text-[16px] pb-2" >
              Uploaded Files
              </p>
            </Grid>
          </Grid>
        <Box>
          <Grid container alignItems='center' spacing={1}>
            <Grid item xs>
              <DataGrid
                initialState={{
                  columns: {
                    columnVisibilityModel: {
                      // Hide columns status and traderName, the other columns will remain visible
                      id: false,
                    },
                  },
                }}
                pagination
                autoPageSize
                style={{ width: "100%", height: "255px", padding: "10px" }}
                columnHeaderHeight={30}
                rowHeight={30}
                rows={rows}
                columns={columns}
                sx={{
                  '& .MuiDataGrid-columnHeaders': {
                    color: 'var(--color-primary-purple)'
                  },
                  '& .MuiDataGrid-columnHeaderTitle': {
                    fontWeight: 700,
                  },
                }}
              />
            </Grid>
          </Grid>
        </Box>
        <Box sx={{ marginTop: 3 }}>
          <Grid container style={{ display:'flex', justifyContent:'center', alignItems:'center', gap:'50px'}}>
            <Grid item >
              <input type='file' multiple onChange={selectFiles} />
            </Grid>
            <Grid item>
              <button
                className={`text-white ${selectedFiles ? 'bg-[var(--color-primary-purple)]': 'bg-gray-500'} px-4 py-1 rounded-md`}
                disabled={!selectedFiles}
                onClick={uploadFiles}
              >
                Upload
              </button>
            </Grid>
          </Grid>
        </Box>
        {progressInfos && progressInfos.val.length > 0 && 
        (
          <>
            <h1 className="font-bold text-[var(--color-primary-purple)] mt-3 text-lg">Result</h1>
            <div className='' style={divStyle}>
            {       
              progressInfos.val.map((progressInfo, index) => (
                <div className='px-4 py-2 w-full m-1' key={index}>
                  <Typography color='text.secondary' variant='body2'>
                    {progressInfo.fileName}
                  </Typography>
                  <div className='progress'>
                    <div
                      className='progress-bar progress-bar-info'
                      role='progressbar'
                      aria-valuenow={progressInfo.percentage}
                      aria-valuemin='0'
                      aria-valuemax='100'
                      style={{ width: progressInfo.percentage + "%", backgroundColor:'var(--color-primary-purple)' }}
                    >
                      {progressInfo.percentage}%
                    </div>
                  </div>
                </div>
              ))
            }
          
            </div>
          </>
        )
        }

        {message && <>
          <div className="mt-2">
            {message.toString().split(',').map((x,i) => (
              <p className="px-2 font-semibold text-[14px]" key={i}>{x}</p>
            ))}
          </div>
        </>}

      </Box>
        
    </div>
  );
}

export default FileUpload;
